export const trimSeries = (calendar, data=[], cb) => {
  let start = calendar[0];
  let end = calendar[calendar.length - 1];
  if(cb){
    return cb(data.slice(start.dayLookup - 1, end.dayLookup))
  }
  return data.slice(start.dayLookup - 1, end.dayLookup).map(({value}) => value);
};